import styled from 'styled-components';

import { Link } from 'react-router-dom';

//Estructura principal de todos de los botones de la página
const Boton = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    background-color:${(props) => (props.temario ? "white" : "#EE805D")};
    font-weight: 500;
    display: inline-block;
    line-height: 1;
    font-family: 'Roboto', sans-serif;
    border-radius: 3px;
    border: ${(props) => (props.temario ? "1px solid #757575" : "none")};
    color: ${(props) => (props.temario ? "#757575" : "#fff")};
    text-align: center;
    text-decoration: none;
    padding: ${(props) => (props.form ? "15px 20px 15px 20px" : "12px 18px 12px 18px")};
    
    
    
    margin-top: 2%;
    font-size: 15px;
    margin-left: ${(props) => (props.alineado ? "40%" : (props.temario ? "3%" : ""))};
    cursor: pointer;
	transition: .3s ease all;


    @media (max-width: 1150px) {
        margin-left: ${(props) => (props.alineado ? "20%" : "")};
    }

    @media (max-width: 2150px) {
        margin-left: ${(props) => (props.alineado ? "40%" : "")};
    }

    
    &:hover {
		background-color:${(props) => (props.temario ? "#EE805D" : props.form ? "black" : "white")};
        color: ${(props) => (props.temario ? "white" : props.form ? "white" : "#EE805D")};
        border: ${(props) => (props.temario ? "1px solid #EE805D" : "1px solid #EE805D")};
        
	}
 
    
`;

export default Boton;